import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CubeIcon = createIcon({
  displayName: 'CubeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4,8l8,-5l8,5v8l-8,5l-8,-5v-8l8,4.375v8.625v-8.625l8,-4.375"
        ></path>
      </g>
    </>
  ),
})

const Cube: FC<IconProps> = (props) => {
  return <CustomIcon as={CubeIcon} {...props} />
}

export default memo(Cube)
